import { SanityVideo, SanityVideoType } from '@data/sanity/queries/types/video'

import MuxVideo from '@components/video/mux-video'

const VideoModule = ({
  type,
  muxVideo,
  settings,
  aspectRatio,
  borderRadius,
  thumbnailImage,
}: SanityVideo) => (
  <>
    {type === SanityVideoType.MUX && muxVideo && (
      <MuxVideo
        video={muxVideo}
        showControls={settings?.controls}
        autoplay={settings?.autoplay}
        autoplayOnHover={settings?.autoplayOnHover}
        openModalOnClick={settings?.openModalOnClick}
        loop={settings?.loop}
        muted={settings?.muted}
        borderRadius={borderRadius}
        aspectRatio={aspectRatio}
        thumbnailImage={thumbnailImage}
      />
    )}
  </>
)

export default VideoModule
